import React, { ReactNode } from "react";
import { Tooltip } from "antd";
import { TooltipPlacement, TooltipTrigger } from "antd/lib/tooltip";
import styled from "styled-components";
import { FiInfo } from "@react-icons/all-files/fi/FiInfo";

interface IBuxTooltipProps {
  placement?: TooltipPlacement;
  content: string | ReactNode | JSX.Element;
  trigger: TooltipTrigger;
  style?: React.CSSProperties;
  allowClickThrough?: boolean;
  iconSize?: number;
}

const StyledInfo = styled(FiInfo)`
  stroke: #434a54;
  fill: transparent;
  margin-left: 5px;
  transition: fill 0.3s, stroke 0.3s;
  > circle {
    stroke: #434a54;
  }
  &:hover {
    stroke: white;
    fill: #434a54;
    > circle {
      stroke: #434a54;
    }
  }
`;

export const BuxTooltip = (props: IBuxTooltipProps) => {
    return (
        <Tooltip
            placement={props.placement ? props.placement : "left"}
            title={props.content}
            trigger={props.trigger ? props.trigger : "click"}
        >
            <StyledInfo
                size={props.iconSize ? props.iconSize : 14}
                style={props.style}
                onClick={
                    props.allowClickThrough ? null : (event) => event.stopPropagation()
                }
            />
        </Tooltip>
    );
};
